import styled from 'styled-components';

export const StyledSteps = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin: 0 0 16px;

  @media (min-width: 992px) {
    justify-content: flex-start;
  }

  button {
    font-size: 16px;
    line-height: 20px;
    color: var(--light-gray);

    &.active {
      font-weight: 700;
      color: var(--turquoise);
    }
  }
`;

export const StyledAccountSetupStep3 = styled.div`
  .content-holder {
    padding: 0 0 20px;
    overflow: hidden;

    .list {
      padding-left: 20px;
      margin: 0 0 20px;

      li {
        list-style: decimal;
        margin: 0 0 10px;
      }
    }
    a {
      font-style: italic;
      font-weight: 500;
      color: var(--green);
    }
    .instruction-text {
      display: block;
      margin: 0 0 15px;
    }

    .card {
      padding: 15px 20px;
      background: #eff5fd;
      color: var(--text-color-50);
      border: 1px solid rgb(185, 206, 238);
      border-radius: 16px;
      margin: 0 0 16px;

      .heading {
        display: block;
        font-size: 18px;
        line-height: 24px;
        font-weight: 700;
        margin: 0 0 16px;
      }

      .subheading {
        display: block;
        margin: 0 0 12px;
      }

      .card-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .accounts-counter {
          width: max-content;
          display: flex;
          align-items: center;
          gap: 4px;
          font-weight: 700;
          background: var(--white);
          padding: 6px 8px;
          border-radius: 16px;
        }

        .connect-btn {
          background: var(--white);
          font-weight: 700;
          color: #2679f3;
          padding: 6px 8px;
          border-radius: 16px;
          transition: 0.3s;

          &:hover,
          &.active {
            background: #2679f3;
            color: var(--white);
          }
        }
      }
    }

    form {
      height: 0;
      opacity: 0;
      visibility: hidden;
      transform: translateY(50px);
      transition: 0.4s;
      overflow-y: auto;
      padding: 0 5px 0 0;
    }

    &.active {
      form {
        height: 366px;
        opacity: 1;
        visibility: visible;
        transform: translateY(0);
        margin: 0 0 16px;
      }
    }

    img {
      width: 20px;
      height: 20px;
      border-radius: 50px;
      object-fit: cover;
    }
  }

  .content-holder:has(.react-select__control--menu-is-open) .skip-button {
    z-index: -1;
  }

  .react-select__menu-list {
    max-height: 175px;
  }
`;

export const StyledOnboarding = styled.div`
  form {
    margin: 0 0 20px;
  }
  .role-holder {
    background: var(--white);
    border: 1px solid #dfdfdf;
    border-radius: 50px;
    padding: 15px 20px;
    margin: 0 0 16px;

    &:last-child {
      margin: 0 0 36px;
    }

    label {
      margin: 0;
    }
  }
`;

export const StyledBilling = styled.div`


  form {
    margin: 0 0 10px;
  }
  .stripe-input {
    height: 50px;
    display: flex;
    align-items: center;
    flex-grow: 1;
    background: var(--white);
    border: 1px solid var(--gray-50);
    border-radius: 60px;
    margin: 0 0 16px;
    padding: 0 20px;

    .StripeElement {
      width: 100%;
    }
  }

  .two-col {
    display: flex;
    gap: 16px;

    &.expiry-col {
      /* border-bottom: 1px solid var(--gray-50); */
      /* padding: 0 0 16px; */
      margin: 0 0 40px;

      .stripe-input {
        margin: 0;
      }
    }
  }

  .plan-holder {
    background: #eff5fd;
    color: var(--text-color-50);
    border: 1px solid rgb(185, 206, 238);
    border-radius: 16px;
    padding: 15px 20px;
    margin: 0 0 20px;
    position: relative;

    .head,
    .heading-holder,
    .price-holder,
    .plas-selection {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
    }

    .plas-selection,
    .head {
      margin: 0 0 12px;
    }

    .plan-btns {
      width: max-content;
      display: flex;
      border: 1px solid rgb(185, 206, 238);
      border-radius: 50px;
      overflow: hidden;

      button {
        width: max-content;
        font-size: 12px;
        line-height: 16px;
        padding: 5px 8px;

        &.active {
          background: #2679f3;
          color: var(--white);
        }
      }
    }

    .plans-select {
      width: 100%;
      max-width: 185px;

      .react-select__control {
        min-height: auto;
        font-size: 14px;
        line-height: 18px;
        border-radius: 60px;
        box-shadow: none;
        background: transparent;
        border: 1px solid rgb(185, 206, 238);

        &.react-select__control--is-focused,
        &.react-select__control--menu-is-open {
          border-color: #2679f3;
        }
      }

      .react-select__menu {
        border-radius: 12px;
      }

      .react-select__option,
      .react-select__control {
        font-size: 14px;
        line-height: 18px;
      }

      .react-select__indicators {
        height: 25px;
      }

      .react-select__indicator-separator {
        display: none;
      }
    }

    .heading-holder {
      .img-holder {
        width: 45px;
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50px;
        box-shadow: 0px 0.94px 15.53px 0px #2679f3 inset;
      }

      .heading {
        display: block;
        font-size: 18px;
        line-height: 24px;
        font-weight: 700;
      }
    }

    .price-holder {
      .price {
        display: block;
        font-size: 32px;
        line-height: 36px;
        font-weight: 700;
        color: #2679f3;
      }

      .text {
        display: block;

        &.light {
          font-size: 14px;
          font-weight: 18px;
          color: #2679f3;
        }

        &.bold {
          font-weight: 600;
        }
      }
    }

    .continue-text {
      font-size: 14px;
      line-height: 18px;

      a {
        font-weight: 700;
        font-style: italic;
        color: #2679f3;
      }
    }
  }
`;
